<template>
  <v-container>
    <v-layout row wrap justify-center class="mt-5">
      <v-flex xs12 sm6 md5>
        <v-card class="pa-4">
          <v-form ref="form" @submit.prevent="doLogin">
            <v-container>
              <h1 class="primary--text">Admin Login</h1>
              <p class="grey--text">Enter your email address and password</p>

              <app-alert type="error" :outline="true" :message="error"/>
              <v-layout row wrap class="mb-2">
                <v-flex xs12>
                  <v-text-field
                    label="Email Address"
                    type="email"
                    v-model="credentials.email"
                    :rules="[rules.email]"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap class="mb-2">
                <v-flex xs12>
                  <v-text-field
                    label="Password"
                    type="password"
                    v-model="credentials.hash"
                    :rules="[rules.password]"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout class="align-center">
                <v-btn depressed color="accent" type="submit" :disabled="isLoading">
                  Login
                  <v-progress-circular
                    class="ml-3"
                    :indeterminate="true"
                    :size="18"
                    :width="2"
                    v-if="isLoading"
                  ></v-progress-circular>
                </v-btn>
                <v-spacer></v-spacer>
                <router-link to="/auth/reset" class="small">Forgot Password?</router-link>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
    <MainFooter/>
  </v-container>
</template>

<script>
import MainFooter from '@/components/Footer/MainFooter.vue'
import { AUTH_LOGIN } from '@/store/actions/auth'

export default {
  name: 'Login',
  components: {
    MainFooter
  },
  data () {
    return {
      credentials: {
        email: '',
        hash: '',
        remember: 'true'
      },
      isLoading: false,
      error: false,
      rules: {
        password: value => value.trim() === '' ? 'Password is required for login' : true,
        email: value => !(/\S+@\S+\.\S+/).test(value.trim()) ? 'Enter a valid email' : true
      }
    }
  },
  methods: {
    doLogin () {
      if (!this.$refs.form.validate()) return
      this.error = false
      this.isLoading = true
      this.$store
        .dispatch(AUTH_LOGIN, { isAdmin: true, credentials: this.credentials })
        .then(() => this.$router.push({ name: 'dashboard' }))
        .catch(error => (this.error = error.message))
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>
